import printPDF from 'print-js'

const print = (url, onLoading) => {
    const ext = url.split('.').pop()
    if (ext === 'pdf' && typeof onLoading === "function") {
        onLoading(true)
        printPDF({
            printable: url,
            type: 'pdf',
            onPrintDialogOpen: () => onLoading(false),
            onPrintDialogClose: () => onLoading(false)
        })
    } else if (ext === 'html' || ext === 'pdf') {
        window.open(url, '_blank')
    } else {
        // window.open(url)
        const w = window.open('', '')
        w.document.write('<html><head>')
        w.document.write('<style>html, body{padding:0 !important; margin:0 !important;}</style>')
        w.document.write('</head><body >')
        w.document.write('<img id="print-image-element" src="' + url + '"/>')
        w.document.write('<script>const img = document.getElementById("print-image-element"); img.addEventListener("load",() => {window.focus(); window.print(); window.document.close(); window.close();});</script>')
        w.document.write('</body></html>')
    }
}

export default print
